import fetchUserData from "../data/fetchUserData";

// Redirect to subscription page if not subscribed
export default async function ({ app, redirect, $config }) {
  let userData = app.$localStore.get("userData");
  // Check user data in local storage
  if (!userData) {
    // If not subscribed, fetch updated user data
    const userData = await fetchUserData($config);
    // Update local storage
    app.$localStore.set("userData", userData);
  }

  // Check and redirect if not subscribed
  if (userData.userType !== "consulente") {
    return redirect("/pianifica/locale");
  }
}
